import { InspectorText } from './InspectorText';

interface MarketAccountDisplayProps {
  marketAccount: string;
  marketAccountsByName: Map<string, any> | undefined;
}

export const MarketAccountDisplay = ({ marketAccount, marketAccountsByName }: MarketAccountDisplayProps) => {
  const account = marketAccountsByName?.get(String(marketAccount));
  const displayName = account?.DisplayName ?? marketAccount;
  return <InspectorText>{displayName}</InspectorText>;
};
